import Typography from '@mui/material/Typography'
import { FC, useCallback } from 'react'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useDialogConfirmation } from '../../hooks/useDialogConfirmation'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

type Props = {
    open: boolean
    handleClose: VoidFunction
    id: string
}

export const ProjectDeleteDialog: FC<Props> = ({ open, handleClose, id }) => {
    const { deleteWorkplace, isLoadingDeleteWorkplace } = useAssistantAdministrationStore(
        (state) => state,
    )

    const handleClickDelete = useCallback(async () => {
        await deleteWorkplace({ workplaceId: id })
        window.open(`/records?is_archived=false`, '_self')
    }, [deleteWorkplace])

    const { isOpen, dialogProps, close, submit } = useDialogConfirmation({
        open,
        onClose: handleClose,
        onSubmit: handleClickDelete,
        baseDialogProps: {
            title: 'Удалить проект?',
            submitButtonText: 'Удалить',
            message:
                'Вы собираетесь удалить проект. Это действие приведет к безвозвратному удалению всех данных, связанных с проектом, включая: записи, запросы и встречи',
        },
        confirmationDialogProps: {
            title: 'Подтвердить удаление',
            submitButtonText: 'Подтвердить',
            message:
                'Эти данные не могут быть восстановлены после удаления. Вы уверены, что хотите подтвердить удаление?',
        },
    })

    return (
        <ConfirmDialogWrapper
            open={isOpen}
            handleSubmit={submit}
            handleClose={close}
            title={dialogProps.title}
            submitButtonText={dialogProps.submitButtonText}
            closeButtonText={dialogProps.closeButtonText}
            isDisabled={isLoadingDeleteWorkplace}>
            <Typography variant="body1">{dialogProps.message}</Typography>
        </ConfirmDialogWrapper>
    )
}
